import NextLink from 'next/link';
import { useRouter } from 'next/router';

import { cn } from '@playbooks/ui/lib/utils';

import type { DocsSection } from 'types/docs';

const DocsSidebarFragment = ({ sections, onNavigate }: { sections: DocsSection[]; onNavigate?: () => void }) => {
	const router = useRouter();
	const currentPath = router.asPath.split('?')[0].split('#')[0];

	return (
		<nav aria-label='Documentation navigation'>
			<div className='space-y-8'>
				{sections.map(section => (
					<div key={section.id}>
						<p className='type-pretitle mb-3 px-1'>{section.title}</p>
						<ul className='space-y-0.5 border-l border-border'>
							{section.pages.map(page => {
								const active = currentPath === page.href;
								const linkClassName = cn(
									'-ml-px block border-l px-4 py-1.5 text-sm leading-5 transition-colors',
									active
										? 'border-border-strong bg-surface-hover text-foreground'
										: 'border-transparent text-foreground-body hover:border-border-strong hover:bg-surface-hover hover:text-foreground',
								);
								return (
									<li key={page.href}>
										<NextLink
											href={page.href}
											onClick={onNavigate}
											aria-current={active ? 'page' : undefined}
											className={linkClassName}>
											{page.title}
										</NextLink>
									</li>
								);
							})}
						</ul>
					</div>
				))}
			</div>
		</nav>
	);
};

export { DocsSidebarFragment };
